// Định dạng số kiểu Việt Nam (dấu chấm ngăn hàng nghìn, dấu phẩy thập phân)
// cho các ô nhập Đơn giá/Khối lượng — xem components/MDInputSo. Gõ "10000"
// hiện ngay "10.000" trong khi giá trị đưa ra ngoài (onChange) vẫn là chuỗi
// số thuần ("10000"/"12.5") để chỗ dùng không phải đổi Number(...) đang có.

// Từ chuỗi vừa gõ (có thể lẫn dấu chấm hiển thị cũ do là input có kiểm soát):
// chỉ giữ chữ số, và giữ đúng 1 dấu phẩy đầu tiên nếu cho phép thập phân.
export function locChuoiNhap(raw, choPhepThapPhan) {
  const daLoc = raw.replace(choPhepThapPhan ? /[^\d,]/g : /[^\d]/g, "");
  if (!choPhepThapPhan) return daLoc;
  const viTri = daLoc.indexOf(",");
  if (viTri === -1) return daLoc;
  return daLoc.slice(0, viTri + 1) + daLoc.slice(viTri + 1).replaceAll(",", "");
}

// Chuỗi đã lọc ("12,50") -> chuỗi số thuần dùng Number()/parseFloat được
// ngay ("12.5"). Rỗng -> "" (phân biệt "chưa nhập gì" với "nhập số 0").
export function locThanhSoThuan(chuoiLoc) {
  if (chuoiLoc === "") return "";
  const [nguyen, thapPhan] = chuoiLoc.split(",");
  const nguyenSach = nguyen.replace(/^0+(?=\d)/, "") || "0";
  return thapPhan === undefined ? nguyenSach : `${nguyenSach}.${thapPhan}`;
}

// Chuỗi đã lọc ("1250000" hoặc "12,50") -> chuỗi hiển thị có dấu chấm ngăn
// hàng nghìn ("1.250.000" / "12,50") — giữ nguyên trạng thái đang gõ dở (dấu
// phẩy chưa có số theo sau, số 0 cuối phần thập phân).
export function locThanhChuoiHienThi(chuoiLoc) {
  if (chuoiLoc === "") return "";
  const [nguyen, thapPhan] = chuoiLoc.split(",");
  const nguyenSach = nguyen.replace(/^0+(?=\d)/, "") || "0";
  const nguyenCoDau = nguyenSach.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return thapPhan === undefined ? nguyenCoDau : `${nguyenCoDau},${thapPhan}`;
}

// Giá trị số thuần đến từ bên ngoài (props, dữ liệu nạp lại khi sửa) -> chuỗi
// hiển thị có dấu phân cách — dùng để đồng bộ ô nhập khi giá trị đổi từ
// ngoài vào (không phải do chính ô đó vừa gõ).
export function soThanhChuoiHienThi(value) {
  if (value === "" || value === null || value === undefined) return "";
  const chuoiChuan = String(value).replace(".", ",");
  return locThanhChuoiHienThi(locChuoiNhap(chuoiChuan, true));
}

// Ngược lại: đọc số thực từ đúng chuỗi đang hiển thị trong ô (đã có dấu
// chấm ngăn hàng nghìn) — dùng để so sánh chống bị format đè lúc đang gõ dở
// phần thập phân (vd "12,50" và "12,5" cùng là số 12.5 nhưng khác chuỗi).
export function chuoiHienThiThanhSo(chuoiHienThi) {
  if (chuoiHienThi === "") return "";
  return Number(chuoiHienThi.replaceAll(".", "").replace(",", "."));
}
